import { useEffect, useState } from 'react';
/**
 * useMediaQuery — subscribes to a CSS media query and returns whether it
 * currently matches. Used by the V2 proposal shell to switch between a
 * resizable side panel (desktop) and a slide-in sheet (narrow viewports).
 */ export function useMediaQuery(query) {
    const getInitial = ()=>{
        if (typeof window === 'undefined') return false;
        return window.matchMedia(query).matches;
    };
    const [matches, setMatches] = useState(getInitial);
    useEffect(()=>{
        if (typeof window === 'undefined') return;
        const mql = window.matchMedia(query);
        const handler = (e)=>setMatches(e.matches);
        setMatches(mql.matches);
        mql.addEventListener('change', handler);
        return ()=>mql.removeEventListener('change', handler);
    }, [
        query
    ]);
    return matches;
}
